import { AspectRatio, Box, Center, forwardRef, Icon, VStack } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { FaPlay } from 'react-icons/fa'
import loadable from '@loadable/component'

import useImpression from '../../../hooks/useImpression'
import useTracker from '../../../hooks/useTracker'
import LinkStats from '../../../adminComponents/ProfileEditor/LinkStats'

const YoutubePlayer = loadable(() => import('./YoutubePlayer'), { ssr: false })

const youtubePttn = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//
const spotifyPttn = /https?:\/\/(?:open\.|play\.)?spotify\.com\/(?:track\/|embed\/|\?uri=spotify:track:)?(episode\/|album\/)?([a-zA-Z0-9]{22})/

const Youtube = forwardRef(({ youtubeId, onClick, cover }, ref) => {
  // const [measureRef, playerSize] = useMeasure()
  return (
    <div ref={ref}>
      <YoutubePlayer
        key={youtubeId}
        videoId={youtubeId}
        onClick={onClick}
        cover={cover}
      />
    </div>
  )
})

const SpotifyIframe = forwardRef(({ spotify: { id, type }, onClick }, ref) => {
  if (type === 'episode/') {
    return (
      <Box
        onClick={onClick}
        as="iframe"
        borderRadius="xl"
        src={`https://open.spotify.com/embed/episode/${id}`}
        width="100%"
        height="232px"
        frameBorder="0"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        ref={ref}
      />
    )
  }
  return <div ref={ref} />
})

const IframePlayer = ({
  url,
  isPreview,
  isEditing,
  id: blockId,
  profileId,
  impressions,
  clicks,
  image,
}) => {
  const showPreview = isPreview || isEditing
  const isYoutube = useMemo(() => youtubePttn.exec(url), [url])
  const isSpotify = useMemo(() => spotifyPttn.exec(url), [url])
  const ref = useImpression(profileId, blockId, blockId)
  const clickTrack = useTracker('click', true)
  let Player = 'div'
  if (isYoutube) {
    Player = Youtube
  } else if (isSpotify) {
    Player = SpotifyIframe
  }
  const child = url ? (
    <Player
      url={url}
      youtubeId={isYoutube?.[1]}
      spotify={{
        id: isSpotify?.[2],
        type: isSpotify?.[1],
      }}
      blockId={blockId}
      itemId={blockId}
      profileId={profileId}
      ref={!isEditing && !isPreview ? ref : undefined}
      onClick={() => !isEditing && !isPreview && clickTrack(profileId, blockId, blockId)}
      cover={image}
    />
  ) : (showPreview ? (
    <AspectRatio ratio={16 / 9}>
      <Center as={VStack} bg="gray.100" borderRadius="xl">
        <Icon w={8} h={8} as={FaPlay} />
      </Center>
    </AspectRatio>
  ) : null)
  return isEditing ? (
    <LinkStats
      blockId={blockId}
      itemId={blockId}
      profileId={profileId}
      impressions={impressions}
      clicks={clicks}
    >{child}</LinkStats>
  ) : child
}

export default IframePlayer
